import { FC } from "react";
import ModalComponent from "../../shared/base-components/Modal";

import { Col, Row, Table } from "reactstrap";
import { TodoDetailModalProps } from "./Todo.constants";
import { formatDateString } from "../../shared/utils/formatText";

const TodoDetailModal: FC<TodoDetailModalProps> = ({
  userData,
  isModalOpen,
  toggle,
}) => {
  const color = userData?.person_who_complete !== null ? "success" : "warning";

  return (
    <ModalComponent
      header={"İş Bilgileri"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Row>
        <Col lg={12}>
          <div className="border rounded">
            <div className="table-responsive">
              <Table className="table-nowrap align-middle mb-0">
                <tbody>
                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"İş adı:"}</h5>

                    <td className="text-start">{userData?.name}</td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Açıklama:"}</h5>

                    <td style={{ whiteSpace: "normal" }} className="text-start">
                      {userData?.description}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Son tarih:"}</h5>

                    <td className="text-start">
                      {formatDateString(userData?.date || "Yok")}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Atanan kişi:"}</h5>

                    <td className="text-start">
                      {userData?.person_who_assign.fullname}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Tamamlayan:"}</h5>

                    <td className="text-start">
                      {userData?.person_who_complete !== null
                        ? userData?.person_who_complete.fullname
                        : "Yok"}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">
                      {"Oluşturulma Tarihi:"}
                    </h5>

                    <td className="text-start">
                      {formatDateString(userData?.created_at || "Yok")}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Durum:"}</h5>

                    <td className="text-start">
                      <div
                        className={
                          "badge bg-" +
                          color +
                          "-subtle text-" +
                          color +
                          " font-size-12"
                        }
                      >
                        {userData?.person_who_complete !== null
                          ? "Tamamlandı"
                          : "Devam Ediyor"}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </Row>
    </ModalComponent>
  );
};

export default TodoDetailModal;
